import { createFileRoute, redirect } from '@tanstack/react-router';
import { TiktokApiClient } from '../../../services/Tiktok';

export const Route = createFileRoute('/auth/tiktok/callback')({
  component: () => <div></div>,
  errorComponent: () => {
    return <div>Error</div>;
  },
  loader: async ({ location }) => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code')!;
    const state = params.get('state')!;

    const serverUrl = TiktokApiClient.getServerUrlFromState(state);

    if (!serverUrl) {
      return redirect({ to: '/auth/$provider/error', params: { provider: 'tiktok' } });
    }

    try {
      await TiktokApiClient.passTiktokCallbackParams({
        code,
        state,
        serverUrl,
      });
    } catch {
      return redirect({ to: '/auth/$provider/error', params: { provider: 'tiktok' } });
    }

    return redirect({ to: '/auth/$provider/success', params: { provider: 'tiktok' }, replace: true });
  },
});
